/**
 * Client-side org → database routing seam (hub-and-spoke —
 * docs/plans/2026-08-09-hub-and-spoke-org-data-plane.md). Mirror of
 * functions/src/utils/orgDb.ts for the browser SDK.
 *
 * Nothing routes through this until the named-DB spike passes; the
 * /platform/db-spike page uses it to take the measurement.
 */

import { getFirestore, Firestore } from 'firebase/firestore';
import app from '../firebase';

export const DEFAULT_DATABASE_ID = '(default)';

const instances = new Map<string, Firestore>();

export function firestoreForDatabase(databaseId?: string | null): Firestore {
  const id =
    databaseId && databaseId.trim() && databaseId !== DEFAULT_DATABASE_ID
      ? databaseId.trim()
      : DEFAULT_DATABASE_ID;
  let db = instances.get(id);
  if (!db) {
    db = id === DEFAULT_DATABASE_ID ? getFirestore(app) : getFirestore(app, id);
    instances.set(id, db);
  }
  return db;
}
